module.exports = {
	"name": "angularFileUpload"
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.json
 ** module id = 2
 ** module chunks = 0
 **/